import { render, staticRenderFns } from "./ClassRoomOwnedEdit.vue?vue&type=template&id=203023a5&scoped=true&"
import script from "./ClassRoomOwnedEdit.vue?vue&type=script&lang=js&"
export * from "./ClassRoomOwnedEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203023a5",
  null
  
)

export default component.exports